import gsap from 'gsap';

const magazineObserveFadeCta = () => {
    const button = document.querySelector('.jsMagazineObserveFadeCta');

    if(!button) return;

    const hiddenAnimation = () => {
        if(0 < window.scrollY) {
            gsap.to(button, {
                autoAlpha: 1,
                duration: 0.75
            });
        } else {
            gsap.to(button, {
                autoAlpha: 0,
                duration: 0.75
            });
        }
    }

    window.addEventListener('scroll', hiddenAnimation, { passive: true });
}
export { magazineObserveFadeCta };